import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const organizationConfig = {
  /* ------------------------------- GET ----------------------------------- */

  getAllOrganizations: {
    key: "getAllOrganizations",
    url: "/api/v1/organizations",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  // pms-api returns all orgs; filter client-side if needed
  getOrganizationsWithoutHotelOwner: {
    key: "getOrganizationsWithoutHotelOwner",
    url: "/api/v1/organizations?withoutOwner=true",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  fetchAllOrganizations: {
    key: "fetchAllOrganizations",
    url: "/api/v1/organizations",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },

  getOrganizationById: {
    key: "getOrganizationById",
    url: (params) => {
      const id = params?.id || params;
      return `/api/v1/organizations/${id}`;
    },
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  // TODO: no direct equivalent in pms-api yet
  getOrganizationByCodeWithProperties: {
    key: "getOrganizationByCodeWithProperties",
    url: "/api/v1/organizations",
    method: "GET",
    options: {
      ...QUERY_PRESETS.DETAIL,
    },
  },

  /* ------------------------------- POST ---------------------------------- */

  createOrganization: {
    key: "createOrganization",
    url: "/api/v1/organizations",
    method: "POST",
    options: {
      retry: 2,
      invalidateKeys: ["getAllOrganizations"],
    },
  },

  /* -------------------------------- PATCH -------------------------------- */

  // TODO: pending pms-api implementation
  updateOrganization: {
    key: "updateOrganization",
    url: (data) => `/api/v1/organizations/${data.id}`,
    method: "PATCH",
    options: {
      retry: 2,
      invalidateKeys: ["getAllOrganizations", "getOrganizationById"],
    },
  },
};
